export default "__VITE_ASSET__SNevOzy8__"